export interface TattooEntry {
    date: string; // YYYY-MM-DD for sorting, YYYY-MM or YYYY if approximate
    artist: string;
    instagram?: string;
    location?: string;
}

const tattoos: TattooEntry[] = [
    // 2026
    { date: '2026-06', artist: 'Dan Santoro', instagram: 'dan_santoro', location: 'Hawley, PA' },
    { date: '2026-06', artist: 'Kana Porcelly', instagram: 'letskidnapkana', location: 'Hawley, PA' },
    { date: '2026-05', artist: 'Daniel Strauss', instagram: 'daniel__strauss', location: 'Queens, NYC' },
    { date: '2026-05', artist: 'Akira Latanzio', instagram: 'akira_latanzio', location: 'Queens, NYC' },
    { date: '2026-05', artist: 'Rich Fie', instagram: 'richfie', location: 'Queens, NYC' },
    { date: '2026-04', artist: 'Sergio', instagram: 'splurgeo', location: 'San Diego' },
    { date: '2026-04', artist: 'Thomas Leyh', instagram: 'thomasleyh', location: 'Electric Anvil' },
    { date: '2026-04', artist: 'Holly Berry', instagram: 'hollyberrytattoos', location: 'E Ville Tattoo' },
    { date: '2026-03', artist: 'Carina Novello', instagram: 'carina_novello', location: 'Manhattan' },
    { date: '2026-03', artist: 'Mikey Chestnuts', instagram: 'mikeychestnuts', location: 'Queens, NYC' },
    { date: '2026-03', artist: 'Tyler Raring', instagram: 'tylerraringtattoo', location: 'San Francisco' },
    { date: '2026-03', artist: 'Mike Perfetto', instagram: 'designs_by_michael_angelo', location: 'Brooklyn' },
    { date: '2026-02', artist: 'Hari Seda', instagram: 'hari_seda_tattooer', location: 'San Juan, Puerto Rico' },
    // 2025
    { date: '2025', artist: 'Vince', instagram: 'big_rig_tat2', location: 'Electric Anvil' },
    { date: '2025', artist: 'Sebas Botero', instagram: 'sebasbotero_', location: 'Medellín, Colombia' },
    { date: '2025', artist: 'Leo Rocha', location: 'Vila Velha, Brazil' },
    // 2017 — approximate
    { date: '2017', artist: 'Knarly Gav', instagram: 'knarlygav', location: 'Brooklyn' },
    // 2015
    { date: '2015', artist: 'York Yeh', instagram: 'yeh5050', location: 'Taipei' },
    { date: '2015', artist: 'Nicholas Mudskipper', instagram: 'nicholasmudskipper', location: 'Bangkok' },
    // TBD
    { date: '', artist: 'Tattooist Nini', instagram: 'tattooist_nini', location: 'Seoul' },
    // 2013 — TODO: validate year. Shop in Park Slope, Brooklyn. Artist unknown.
    { date: '2013', artist: 'Unknown', location: 'Park Slope, Brooklyn' },
];

// Sort newest first; empty dates go to the end
tattoos.sort((a, b) => {
    if (!a.date) return 1;
    if (!b.date) return -1;
    return b.date.localeCompare(a.date);
});

export { tattoos };
